<script lang="ts" setup>
import { onMounted, onUnmounted } from "vue";
import { useBaseView } from "@/composables";

const { setTitle } = useBaseView();

const props = defineProps<{
  header: string;
}>();

onMounted(() => {
  setTitle(props.header, null, true);
});

onUnmounted(() => {
  setTitle("");
});
</script>
<template>
  <v-container class="pa-6 pb-0 height-100" fluid>
    <slot />
  </v-container>
</template>

<style lang="scss" scoped></style>
